import React, { useState, useContext } from 'react';
import { RIFieldsLive, RIFieldsUAT } from '../../data/SalesforceFields';
import { useStaticQuery, graphql } from 'gatsby';
import RegisterInterestWrapper from '../wrappers/RegisterInterestWrapper';
import { handleDate } from '../../util/util';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import ProductContext from '../../context/ProductContext';
const BusinessInterestForm = ({
  selectedAddress,
  setSelectedAddress,
  forceReferralCode,
  defaultSource,
  leadSource,
  showSalesFields,
  isModularBlock,
  successPath,
  networkCoverage,
}) => {
  const [contractDate, setContractDate] = useState();
  const [defaultFormData, setDefaultFormData] = useState({});
  const [showFinance, setShowFinance] = useState(false);
  const [showLegal, setShowLegal] = useState(false);
  const { businessData } = useContext(ProductContext);
  const sfFields =
    process.env.NODE_ENV === 'development' ||
    process.env.GATSBY_ENVIRONMENT === 'development'
      ? RIFieldsUAT
      : RIFieldsLive;

  const defaultFormDataField = defaultFormData?.Parameters;
  const returnPath = businessData?.businessLineOnly
    ? 'business-residential-register-interest-success'
    : networkCoverage
      ? 'business-register-interest-orderable-success'
      : 'business-register-interest-success';

  return (
    <RegisterInterestWrapper
      isModularBlock={isModularBlock}
      selectedAddress={selectedAddress}
      setSelectedAddress={setSelectedAddress}
      forceReferralCode={forceReferralCode}
      defaultSource={defaultSource}
      leadSource={leadSource}
      showSalesFields={showSalesFields}
      successPath={successPath ?? returnPath}
      setContractDate={setContractDate}
      contractDate={contractDate}
      defaultFormData={defaultFormData}
      setDefaultFormData={setDefaultFormData}
      sfFields={sfFields}
    >
      <div className="form-input-inner column-1">
        <label for={sfFields.primaryContactRole}>
          Position<span>*</span>
        </label>
        <input
          type="text"
          placeholder="Position"
          name={sfFields.primaryContactRole}
          id={sfFields.primaryContactRole}
          role={showSalesFields && 'presentation'}
          required
        />
      </div>
      <div className="form-input-inner column-3">
        <label for={sfFields.companyName}>
          Company Name<span>*</span>
        </label>
        <input
          type="text"
          placeholder="Company Name"
          name={sfFields.companyName}
          id={sfFields.companyName}
          role={showSalesFields && 'presentation'}
          required
        />
      </div>
      <div className="form-input-inner column-1">
        <label for={sfFields.companyNumber}>
          Company Number<span>*</span>
        </label>
        <input
          type="number"
          placeholder="Company Number"
          name={sfFields.companyNumber}
          id={sfFields.companyNumber}
          role={showSalesFields && 'presentation'}
        />
      </div>
      <div className="form-input-inner column-3">
        <label for={sfFields.vatNumber}>
          Company VAT Number<span>*</span>
        </label>
        <input
          type="text"
          placeholder="Company VAT Number"
          name={sfFields.vatNumber}
          id={sfFields.vatNumber}
          role={showSalesFields && 'presentation'}
        />
      </div>

      <div className="form-input-inner column-1">
        <label for={sfFields.email}>
          Email<span>*</span>
        </label>
        <input
          type="email"
          placeholder="Email address"
          name={sfFields.email}
          id={sfFields.email}
          defaultValue={defaultFormDataField?.Email}
          required
          onChange={(event) => event.target.setCustomValidity('')}
          role={showSalesFields && 'presentation'}
        />
      </div>
      <div className="form-input-inner column-3">
        <label for={sfFields.phone}>
          Phone Number<span>*</span>
        </label>
        <input
          type="tel"
          placeholder="Phone Number"
          name={sfFields.phone}
          defaultValue={defaultFormDataField?.Contactno}
          id={sfFields.phone}
          required
          role={showSalesFields && 'presentation'}
        />
      </div>
      <div className="form-input-section-heading">
        <h4>Alternative Contacts</h4>
      </div>
      <div className="form-dropdown-container column-1">
        <div className="form-input-section-heading">
          <h4 className="form-heading-flex">
            Finance contact{' '}
            <div className="form-show-more">
              <button
                type="button"
                onClick={() => setShowFinance(!showFinance)}
              >
                <div
                  className={`${
                    showFinance ? 'form-arrow-rotate' : 'form-arrow'
                  }`}
                >
                  <FontAwesomeIcon icon={faChevronDown} />
                </div>
              </button>
            </div>
          </h4>
        </div>
        {showFinance && (
          <>
            {' '}
            <div className="form-input-inner column-1">
              <label for={sfFields.alternativeContactRole}>
                Role<span>*</span>
              </label>
              <input
                type="text"
                placeholder="Role"
                name={sfFields.alternativeContactRole}
                id={sfFields.alternativeContactRole}
                role={showSalesFields && 'presentation'}
              />
            </div>{' '}
            <div className="column-3">
              <div className="form-column-input-split">
                <div className="form-input-inner">
                  {' '}
                  <label for={sfFields.alternativeContactEmail}>
                    Email<span>*</span>
                  </label>
                  <input
                    type="email"
                    placeholder="Email"
                    name={sfFields.alternativeContactEmail}
                    id={sfFields.alternativeContactEmail}
                    role={showSalesFields && 'presentation'}
                  />
                </div>
                <div className="form-input-inner">
                  {' '}
                  <label for={sfFields.alternativeContactPhone}>
                    Phone Number<span>*</span>
                  </label>
                  <input
                    id={sfFields.alternativeContactPhone}
                    type="tel"
                    placeholder="Phone Number"
                    name={sfFields.alternativeContactPhone}
                    role={showSalesFields && 'presentation'}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className="form-dropdown-container column-3">
        <div className="form-input-section-heading">
          <h4 className="form-heading-flex">
            Legal{' '}
            <div className="form-show-more">
              <button type="button" onClick={() => setShowLegal(!showLegal)}>
                <div
                  className={`${
                    showLegal ? 'form-arrow-rotate' : 'form-arrow'
                  }`}
                >
                  <FontAwesomeIcon icon={faChevronDown} />
                </div>{' '}
              </button>
            </div>
          </h4>{' '}
        </div>
        {showLegal && (
          <>
            <div className="form-input-inner column-1">
              <label for={sfFields.alternativeContact2Role}>
                Role<span>*</span>
              </label>
              <input
                id={sfFields.alternativeContact2Role}
                type="text"
                placeholder="Role"
                name={sfFields.alternativeContact2Role}
                role={showSalesFields && 'presentation'}
              />
            </div>{' '}
            <div className="column-3">
              <div className="form-column-input-split">
                <div className="form-input-inner">
                  {' '}
                  <label for={sfFields.alternativeContact2Email}>
                    Email<span>*</span>
                  </label>
                  <input
                    id={sfFields.alternativeContact2Email}
                    type="email"
                    placeholder="Email"
                    name={sfFields.alternativeContact2Email}
                    role={showSalesFields && 'presentation'}
                  />
                </div>
                <div className="form-input-inner">
                  {' '}
                  <label for={sfFields.alternativeContact2Phone}>
                    Phone Number<span>*</span>
                  </label>
                  <input
                    id={sfFields.alternativeContact2Phone}
                    type="tel"
                    placeholder="Phone Number"
                    name={sfFields.alternativeContact2Phone}
                    role={showSalesFields && 'presentation'}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className="form-input-section-heading">
        <h4>Tell us about your current provider</h4>
      </div>
      <div className="form-input-inner column-1">
        <label for={sfFields.currentProvider}>Current Provider</label>
        <div className="form-select-arrow">
          <select
            id={sfFields.currentProvider}
            name={sfFields.currentProvider}
            title="Current Provider"
          >
            <option value="">--None--</option>
            <option value="BT / EE">BT / EE</option>
            <option value="Plusnet">Plusnet</option>
            <option value="Virgin Media">Virgin Media</option>
            <option value="Vodafone">Vodafone</option>
            <option value="Sky">Sky</option>
            <option value="Zen">Zen</option>
            <option value="Hyperoptic">Hyperoptic</option>
            <option value="Community Fibre">Community Fibre</option>
            <option value="BRSK">BRSK</option>
            <option value="BeFibre">BeFibre</option>
            <option value="Gigaclear">Gigaclear</option>
            <option value="KCOM">KCOM</option>
            <option value="Rebel">Rebel</option>
            <option value="Truespeed">Truespeed</option>
            <option value="4th Utility">4th Utility</option>
            <option value="Jurassic">Jurassic</option>
            <option value="v4">v4</option>
            <option value="Toob">Toob</option>
            <option value="Trooli">Trooli</option>
            <option value="Cuckoo">Cuckoo</option>
            <option value="Lightspeed">Lightspeed</option>
            <option value="TalkTalk">TalkTalk</option>
            <option value="Other">Other</option>
          </select>
        </div>
      </div>
      <div className="form-input-inner column-3">
        <div className="form-input-date">
          <label for={sfFields.currentlyMonthlyBill}>
            Current Monthly Bill
          </label>
          <input
            id={sfFields.currentlyMonthlyBill}
            name={sfFields.currentlyMonthlyBill}
            type="number"
            placeholder="Current Monthly Bill"
          />
        </div>
      </div>
      <div className="form-input-inner column-1">
        <div className="form-input-date">
          <label for={sfFields.contractEndDate}>Contract End Date</label>
          <input
            type="date"
            name={sfFields.contractEndDate}
            placeholder="End date"
            onChange={(e) => handleDate(e, setContractDate)}
          />
        </div>
      </div>
      <div className="form-input-inner column-1">
        <div className="form-input-section-heading">
          <h4>Is your business registered at this address:</h4>
        </div>
        <p style={{ margin: '1em 0', textAlign: 'left' }}>
          {selectedAddress?.singleLineAddress}
        </p>
      </div>
      <div className="form-input-inner column-3">
        <label for={sfFields.registeredAddressDifferent}>
          Is your business registered at this address:
        </label>
        <div className="form-select-arrow ">
          <select
            id={sfFields.registeredAddressDifferent}
            name={sfFields.registeredAddressDifferent}
            title="Is your business registered at this address:"
          >
            <option value="">--None--</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>{' '}
      </div>
    </RegisterInterestWrapper>
  );
};

export default BusinessInterestForm;
const query = () =>
  useStaticQuery(graphql`
    {
      datoCmsSimpleWebsitePageModel(slug: { eq: "legal/privacy-policy" }) {
        title
        slug
        simpleModularContent {
          ...ModularSimpleHero
          ...ModularParagraph
          ...ModularSimpleContent
        }
      }
    }
  `);
